import _ from 'lodash';
import moment from 'moment';
import store from '../store/index';

import * as fb from '../firebase';
import workspaceService from './workspace.service';

export default {
  getRef(mealId) {
    return fb.mealsCollection.doc(mealId);
  },
  incrementCounter(mealId) {
    this.getRef(mealId).update({
      counter: fb.firestore.FieldValue.increment(1),
    });
  },
  decrementCounter(mealId) {
    this.getRef(mealId).update({
      counter: fb.firestore.FieldValue.increment(-1),
    });
  },

  /**
   * Récupère un meal avec l'id
   * @param {Number} mealId
   */
  getMeal(mealId) {
    return this.getRef(mealId)
      .get()
      .then((meal) => {
        if (meal.exists) {
          return {
            id: mealId,
            ...meal.data(),
          };
        }
        return {};
      });
  },

  /**
   * Enregistrement d'un meal
   * @param {Object} meal
   * @param {Object} workspaceRef
   */
  addMeal(meal, workspaceRef) {
    return fb.mealsCollection.add({
      createdOn: new Date(),
      creatorId: fb.auth.currentUser.uid,
      workspace: workspaceRef,
      counter: 0,
      ...meal,
    });
  },

  /**
   * Modif d'un meal
   * @param {*} meal
   * @param {*} mealId
   */
  updateMeal(meal, mealId) {
    return fb.mealsCollection.doc(mealId).update({
      updatedOn: new Date(),
      ...meal,
    });
  },

  /**
   * Suppression d'un meal
   * @param {*} mealId
   */
  deleteMeal(mealId) {
    return fb.mealsCollection.doc(mealId).delete();
  },

  /**
   * Set the last used date automatically with the plannedMeals
   * @param {Number} mealId
   */
  setAutoLastUsed(mealId) {
    // On prend le dernier planned meal de ce mealId
    this.getLastUsedInPlannedMeals(mealId).then((plannedMeal) => {
      // On récupère la date
      const plannedMealDate = _.get(plannedMeal, 'date', 0);
      // Et on modifie le lastUsed du meal
      this.getRef(mealId).update({
        lastUsed: plannedMealDate,
      });
    });
  },

  /**
   * On récupère le dernier plannedMeal de ce mealId
   * @param {Number} mealId
   */
  getLastUsedInPlannedMeals(mealId) {
    return fb.plannedMealsCollection
      .where('meal.id', '==', mealId)
      .orderBy('date', 'desc')
      .limit(1)
      .get()
      .then((plannedMeals) => {
        if (plannedMeals.docs.length > 0) {
          return plannedMeals.docs[0].data();
        }
        return null;
      });
  },

  getMyMealsSnapshot(allWorkspaces, limit = 50) {
    let workspacesRef = workspaceService.getWorkspacesRef(true);
    if (!allWorkspaces) {
      workspacesRef = [store.state.currentWorkspace.ref];
    }
    return fb.mealsCollection
      .where('workspace', 'in', workspacesRef)
      .limit(limit)
      .orderBy('createdOn', 'desc');
  },

  getLongTimeMeals(limit = 10, fromDate = moment()) {
    const date = fromDate.subtract(2, 'weeks').toDate();
    return fb.mealsCollection
      .where('workspace', '==', store.state.currentWorkspace.ref)
      .where('lastUsed', '<=', date)
      .orderBy('lastUsed', 'asc')
      .limit(limit)
      .get();
  },

  getDefaultMeals() {
    return fb.defaultMealsCollection.get();
  },
};
